export enum VatOption {
  withoutVat = 0,
  withVat = 1,
}